import { AddEmployee, AddPosition, Positions } from '..';

import { EditEmployee } from './EditEmployee';
import { EmailChange } from './EmailChange';
import { EmployeesList } from './EmployeesList';
import { SortEmployees } from './SortEmployees';

export {
  AddEmployee,
  AddPosition,
  EmployeesList,
  Positions,
  EmailChange,
  EditEmployee,
  SortEmployees,
};
